import { defineStore } from 'pinia';
import { WorkerType } from '@/types/Workers';
import { UserType } from '@/types/User';

export const useUserStore = defineStore('user', {
    state: () => ({
        users: [] as Array<WorkerType>,
        confirmUserData: [] as Array<UserType>,
        companyName: '',
    }),

    actions: {
        USERS_DATA(data: any) {
            this.users = data;
        },

        CONFIRM_USER_DATA(data: Array<UserType>) {
            this.confirmUserData = data;
        },

        COMPANY_NAME(data: string) {
            this.companyName = data;
        },
    },
});
